import { Action } from "@ngrx/store";
import { Workspace } from "./workspaces.model";

export enum WorkspaceActionTypes {
  LoadWorkspaces = "[Workspaces] Load Workspaces",
  LoadWorkspacesFailure = "[Workspaces] Load Workspaces Failure",
  SetWorkspaces = "[Workspaces] Set Workspaces",
  CreateWorkspace = "[Workspaces] Create Workspace",
  CreateWorkspaceFailure = "[Workspaces] Create Workspace Failure",
  DeleteWorkspace = "[Workspaces] Delete Workspace",
  DeleteWorkspaceFailure = "[Workspaces] Delete Workspace Failure",
  SetActiveWorkspace = "[Workspaces] Set Active Workspace",
}

export class LoadWorkspaces implements Action {
  readonly type = WorkspaceActionTypes.LoadWorkspaces;
}

export class SetWorkspaces implements Action {
  readonly type = WorkspaceActionTypes.SetWorkspaces;
  constructor(public workspaces: Workspace[]) {}
}

export class LoadWorkspacesFailure implements Action {
  readonly type = WorkspaceActionTypes.LoadWorkspacesFailure;
  constructor(public error: any) {}
}

export class CreateWorkspace implements Action {
  readonly type = WorkspaceActionTypes.CreateWorkspace;
  constructor(public workspace: Workspace) {}
}

export class CreateWorkspaceFailure implements Action {
  readonly type = WorkspaceActionTypes.CreateWorkspaceFailure;
  constructor(public error: any) {}
}

export class DeleteWorkspace implements Action {
  readonly type = WorkspaceActionTypes.DeleteWorkspace;
  constructor(
    public workspace: Workspace,
    public navigate: boolean = true,
  ) {}
}

export class DeleteWorkspaceFailure implements Action {
  readonly type = WorkspaceActionTypes.DeleteWorkspaceFailure;
  constructor(public error: any) {}
}

export class SetActiveWorkspace implements Action {
  readonly type = WorkspaceActionTypes.SetActiveWorkspace;
  constructor(
    public workspace: Workspace | null,
    public navigate: boolean,
  ) {}
}

export type WorkspacesActions =
  | LoadWorkspaces
  | LoadWorkspacesFailure
  | SetWorkspaces
  | CreateWorkspace
  | CreateWorkspaceFailure
  | DeleteWorkspace
  | DeleteWorkspaceFailure
  | SetActiveWorkspace;
